import { useQuery } from '@apollo/client';
import { QUERY } from '../gql-operations';

export const usePlans = () => {
    const { data, loading, error } = useQuery(QUERY.GET_ACTIVE_PLANS, {
        fetchPolicy: 'network-only'
    });

    const plans = {
        subscriptions: data?.getActivePlans?.subscriptions || [],
        oneTimePurchases: data?.getActivePlans?.oneTimePurchases || [],
        oneTimeDeals: data?.getActivePlans?.oneTimeDeals || []
    };

    return {
        plans,
        loading,
        error
    };
}; 